import Grid2 from '@mui/material/Unstable_Grid2';
import { Step } from '../../components/Step';
import { useTranslation } from 'react-i18next';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { TextField } from 'src/shared/components/Form/TextField';
import { Button } from '@mui/material';
import { useFormState } from 'react-final-form';
import { type ConnectCastillaArgs, step2InputList } from '../utils';

type Step2Props = {
  triggerConnection: (args: ConnectCastillaArgs) => void;
  isConnectBtnDisabled: boolean;
};

export const Step2 = ({ triggerConnection, isConnectBtnDisabled }: Step2Props) => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();
  const { subsidiary, baseURL, appName, appToken } = values ?? {};

  return (
    <Step
      title={`${t('integrations.step')} 2`}
      subtitle={t('integrations.castilla.copy your castilla credentials')}
      Icon={VpnKeyIcon}
    >
      <Grid2 xs={12} sx={{ paddingLeft: 0, paddingRight: 0 }}>
        {step2InputList.map(input => (
          <Grid2 xs={12} sx={{ marginBottom: 1 }}>
            <TextField sx={{ width: '300px' }} label={t(input.label)} name={input.name} />
          </Grid2>
        ))}
        <Button
          variant="contained"
          disabled={isConnectBtnDisabled}
          onClick={() => {
            triggerConnection({ subsidiary, body: { baseURL, appName, appToken }, noAutoLogout: true });
          }}
        >
          {t('integrations.connect')}
        </Button>
      </Grid2>
    </Step>
  );
};
